<ion-header>
    <ion-toolbar>
        <ion-title>Score Validation Report</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="close()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-accordion-group>
        <ion-accordion *ngFor="let msv of matchUpScoreValidation" [value]="msv.matchUp.matchUpId">
            <ion-item slot="header">
                <ion-label>#{{ msv.matchUp.collectionPosition }} {{ msv.matchUp.matchType === 'D' ? "Doubles" : "Singles" }}</ion-label>
                <ion-icon [hidden]="msv.scoreIssues.length" name="checkmark" color="success" slot="start"></ion-icon>
                <ion-icon [hidden]="!msv.scoreIssues.length" name="close" color="danger" slot="start"></ion-icon>
            </ion-item>

            <ion-list slot="content">
                <ion-item *ngFor="let si of msv.scoreIssues">
                    <ion-label> {{ '{{ si.errorType }}' | translate }}</ion-label>
                </ion-item>
                <ion-item *ngIf="!msv.scoreIssues.length">
                    <ion-label>Score is valid</ion-label>
                </ion-item>
            </ion-list>
        </ion-accordion>

    </ion-accordion-group>

    <ion-card>
        <ion-card-content>
            <ion-item lines="none">
                <ion-label class="ion-text-wrap">You have one or more match scores the ITA system will not accept due to missing details. Would you like to proceed and complete your score reporting on the ITA Workspace match scorecard?</ion-label>
                <ion-icon slot="start" name="alert-circle" color="warning"></ion-icon>
            </ion-item>

            <ion-row>
                <ion-col size="6">
                    <ion-button (click)="continue()" expand="block" fill="outline">
                        Continue
                    </ion-button>
                </ion-col>
                <ion-col size="6">
                    <ion-button (click)="close()" expand="block">
                        Cancel
                    </ion-button>
                </ion-col>
            </ion-row>

        </ion-card-content>
    </ion-card>

</ion-content>